import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import UploadIcon from "../../../assets/icons/upload-icon";
import DownloadIcon from "../../../assets/icons/download-icon";
import { downloadAllTemplates } from "../../helper-components/helper-function";
import { useFormikContext } from "formik";
import errorToast from "../../helper-components/error-toast";

const GrnCsvImport = ({
  grnCsvImportOpen,
  setGrnCsvImportOpen,
  setIsModalOpen,
  handleFileUpload = () => {},
  tempalteArray = [],
  prefixName = "gort",
}) => {
  const { values } = useFormikContext();

  console.log(tempalteArray, "ggdfgdfgdgdfgd");
  console.log(values?.vendorTemplate, "ggdfgdfgdgdfgd");
  return (
    <Transition show={grnCsvImportOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => setGrnCsvImportOpen(false)}
      >
        <div className="flex min-h-screen px-4 text-center min-w-full">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div
              className="mx-auto mt-2 text-left align-middle transition-all transform bg-white shadow-xl rounded-xl "
              style={{ maxHeight: "35rem", minWidth: "40%" }}
            >
              <div className="h-full flex flex-col">
                <div style={{ height: "calc(100% - 4rem)" }}>
                  <h2
                    className="text-center flex items-center justify-center  border-b border-b-[var(--popup-border)] h-[3rem]    text-[var(--popup-heading-fg-color)] 
               text-[length:var(--popup-heading-font-size)] 
               font-[var(--popup-heading-font-weight)] "
                  >
                    {prefixName === "gort"
                      ? "GRN CSV IMPORT"
                      : "Purchase Invoice Import"}
                  </h2>

                  <div className=" gap-5 w-full flex justify-center mt-10 flex-wrap px-5">
                    {" "}
                    <input
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        // e.target.value = ""; // Reset input value
                        handleFileUpload(e, "vendor");
                      }}
                      className="hidden"
                      id="csv-upload"
                    />
                    <label
                      htmlFor="csv-upload"
                      className="flex flex-col gap-3 items-center justify-center  rounded-[12px] 
               bg-[var(--import-bg)] 
               text-[var(--import-fg)] 
               text-[length:var(--import-button-fs)] 
               font-[var(--import-button-fw)] 
               border border-dashed border-[var(--import-border)] 
               cursor-pointer 
               w-[70%] h-[118px]"
                    >
                      <UploadIcon fill="var(--import-fg)" />
                      <span>Import From Vendor Template</span>
                    </label>
                    {/* Download Template */}
                    <div
                      onClick={() => {
                        if (values?.vendorTemplate?.length > 0) {
                          downloadAllTemplates(values?.vendorTemplate);
                        } else {
                          errorToast("Template is not Available to Download");
                        }
                      }}
                      className="flex flex-col gap-3 items-center justify-center  rounded-[12px] 
               bg-[var(--download-bg)] 
               text-[var(--download-fg)] 
               text-[length:var(--import-button-fs)] 
               font-[var(--import-button-fw)] 
               border border-solid border-[var(--download-border)] 
               cursor-pointer 
               w-[25%]"
                    >
                      <DownloadIcon
                        width="18px"
                        height="18px"
                        fill="var(--download-fg)"
                      />
                      <span>Download Template</span>
                    </div>
                  </div>
                  <div className=" gap-5 w-full flex justify-center mt-5 flex-wrap px-5">
                    <div
                      onClick={() => {
                        setIsModalOpen(true);
                        setGrnCsvImportOpen(false);
                      }}
                      className="flex flex-col gap-3 items-center justify-center  rounded-[12px] 
               bg-[var(--import-bg)] 
               text-[var(--import-fg)] 
               text-[length:var(--import-button-fs)] 
               font-[var(--import-button-fw)] 
               border border-dashed border-[var(--import-border)] 
               cursor-pointer 
               w-[70%] h-[118px]"
                    >
                      <UploadIcon />
                      <span>Common Import</span>
                    </div>

                    {/* Download Template */}
                    <div
                      onClick={() => {
                        downloadAllTemplates(tempalteArray);
                      }}
                      className="flex flex-col gap-3 items-center justify-center  rounded-[12px] 
               bg-[var(--download-bg)] 
               text-[var(--download-fg)] 
               text-[length:var(--import-button-fs)] 
               font-[var(--import-button-fw)] 
               border border-solid border-[var(--download-border)] 
               cursor-pointer 
               w-[25%]"
                    >
                      <DownloadIcon
                        width="18px"
                        height="18px"
                        fill="var(--download-fg)"
                      />
                      <span>Download Template</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GrnCsvImport;
